import { cva } from "class-variance-authority";

export const buttonVariants = cva(
  'py-2 px-4 rounded-sm cursor-pointer flex items-center justify-center gap-2 disabled:cursor-default',
  {
    variants: {
      variant: {
        default: 'bg-primary-blue hover:bg-primary-blue-hover disabled:hover:bg-primary-blue',
        success: 'bg-success hover:bg-success-hover disabled:hover:bg-success',
        yellow: 'bg-yellow-op-2 hover:bg-yellow-hover disabled:hover:bg-yellow-op-2',
        white: 'bg-white-800 hover:bg-white-300 disabled:hover:bg-white-800',
        link: 'bg-transparent p-0 text-blue-800 text-sm hover:text-primary-blue-hover disabled:hover:text-blue-800',
        error: 'bg-danger',
        neutral: 'bg-white-100 hover:bg-white-300 disabled:hover:bg-white-100',
        'yellow-black': 'bg-yellow-600 text-black-900 hover:bg-yellow-hover hover:text-black-900 disabled:hover:bg-yellow-600',
        'link-white': 'text-[#ffffffde] hover:text-[#ffffffde] p-0',
        'outline-success': 'bg-transparent text-valid hover:text-success disabled:hover:text-valid',
        'outline-error': 'bg-transparent text-danger-soft hover:text-danger disabled:hover:text-danger-soft',
        'outline-text': 'bg-transparent italic font-light',
        'outline-disabled': 'bg-transparent text-white-300',
      }
    },
    defaultVariants: {
      variant: 'default',
    }
  }
);
